import { type User, WebStorageStateStore } from 'oidc-client-ts';
import React from 'react';
import { AuthProvider, useAuth } from 'react-oidc-context';

import { listenTokenExpired } from '../../services/api';

const SignInOnExpiredToken = () => {
  const auth = useAuth();
  React.useEffect(() => {
    if (!auth.isAuthenticated) return undefined;
    // sign-out on expired token detected on the client...
    auth.events.addAccessTokenExpired(() => {
      void auth.signinRedirect();
    });
    return listenTokenExpired(() => {
      // ...or if token is expired on the server
      auth.signinSilent().catch(() => {
        void auth.signinRedirect();
      });
    });
  }, [auth.isAuthenticated]);
  return null;
};

const onSigninCallback = (_user: User | void): void => {
  window.history.replaceState({}, document.title, `${window.location.pathname}${window.location.hash}`);
};

const userStore = new WebStorageStateStore({ store: window.localStorage });

export type ProviderAppAuthProps = {
  authority: string;
  children: React.ReactNode;
  client_id: string;
};

export const ProviderAppAuth = (props: ProviderAppAuthProps) => {
  return (
    <AuthProvider
      authority={props.authority}
      client_id={props.client_id}
      includeIdTokenInSilentSignout={true}
      onSigninCallback={onSigninCallback}
      post_logout_redirect_uri={`${window.location.origin}/logout`}
      redirect_uri={window.location.origin + window.location.pathname + window.location.hash}
      revokeTokensOnSignout={true}
      userStore={userStore}
    >
      <SignInOnExpiredToken />
      {props.children}
    </AuthProvider>
  );
};
